<template>
    <div class="l-ss-c-offer-custom-button">
        <app-btn
            v-if="showButton"
            class="l-ss-c-offer-custom-button-btn"
            :loading="loading"
            :disabled="disabled"
            :style="style"
            @click.prevent.stop="onClick">
            <div
                v-if="label || iconBefore || iconAfter"
                class="l-ss-c-offer-custom-button-btn-content">
                <i
                    v-if="iconBefore"
                    v-html="iconBefore"></i>
                <span
                    v-if="label"
                    v-html="label"></span>
                <i
                    v-if="iconAfter"
                    v-html="iconAfter"></i>
            </div>
            <div
                v-else
                class="l-ss-c-offer-custom-button-btn-content">
                <i
                    v-if="icon"
                    v-html="icon"></i>
            </div>
        </app-btn>
    </div>
</template>

<script>
    import { ref, computed } from '@vue/composition-api';
    import AppBtn from '@/core/components/common/app-btn.vue';

    export default {
        components: { AppBtn },
        props: {
            offer: {
                type: Object,
                required: true,
            },
            settings: {
                type: Object,
                required: true,
            },
        },
        setup(props, { emit }) {
            const { offer, settings } = props;
            
            const loading = ref(false);
            const disabled = ref(false);
            const showButton = computed(() => {
                return settings.showButton || true;
            });
            
            const label = computed(() => {
                return settings.label;
            });

            const style = computed(() => {
                return settings.style;
            });
            
            const iconAfter = computed(() => {
                return settings.iconAfter;
            });

            const icon = computed(() => {
                return settings.icon;
            });
            
            const iconBefore = computed(() => {
                return settings.iconBefore;
            });
            
            const onClick = async (event) => {
                if (!settings.onClick) return;
                
                loading.value = true;
                try {
                    await settings.onClick(offer, event);
                    emit('custom-button-click', { offer, event });
                } catch (error) {
                    console.error('Custom button click error:', error);
                } finally {
                    loading.value = false;
                }
            };
            
            return {
                loading,
                disabled,
                showButton,
                label,
                style,
                iconAfter,
                iconBefore,
                icon,
                onClick,
            };
        },
    };
</script>